import Link from 'next/link';

import styles from './cookie-implementation-info-section.module.scss';
import text from './cookie-implementation-info-section.text.json';

export const CookieImplementationInfoSection = () => (
  <p
    className={styles.description}
    data-testid="cookie-implementation-info-section"
  >
    <span className={styles.fullLine}>{text.opener}</span>
    <span>{text.mentioned}</span>
    <Link href="https://www.2.yad2.co.il/privacy" className={styles.link}>
      {text.link}
    </Link>
    <span>{text.ours}</span>
  </p>
);
